var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 22C30.25 26.5563 26.5563 30.25 22 30.25C17.4437 30.25 13.75 26.5563 13.75 22C13.75 17.4437 17.4437 13.75 22 13.75C26.5563 13.75 30.25 17.4437 30.25 22Z",
    strokeWidth: 1.74167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5846 21.9993C26.5846 24.5307 24.5326 26.5827 22.0013 26.5827C19.47 26.5827 17.418 24.5307 17.418 21.9993C17.418 19.468 19.47 17.416 22.0013 17.416C24.5326 17.416 26.5846 19.468 26.5846 21.9993Z",
    strokeWidth: 1.74167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9154 22.0007C22.9154 22.5069 22.505 22.9173 21.9987 22.9173C21.4924 22.9173 21.082 22.5069 21.082 22.0007C21.082 21.4944 21.4924 21.084 21.9987 21.084C22.505 21.084 22.9154 21.4944 22.9154 22.0007Z",
    strokeWidth: 1.74167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion4);
export default __webpack_public_path__ + "static/media/question 4.9a8e9606aa60f4a3b594802d56bf4d67.svg";
export { ForwardRef as ReactComponent };